export default __webpack_public_path__ + "static/media/general.6cdc0489.md";